import { DomainCategory } from "@100mslive/hms-video-store";

export const getAnalyticsEvent = (eventName: string) => {
  return {
    name: eventName,
    level: 1,
    includesPII: false,
    properties: { plugin_name: "HMSKrispPlugin" },
    metadata: { peer: {}, userAgent: "" },
    timestamp: Date.now(),
    device_id: "",
    event_id: Date.now().toString(),
    toSignalParams: () => {
      return {
        name: eventName,
        info: { domain: DomainCategory.CUSTOM, timestamp: Date.now() },
        timestamp: Date.now(),
      };
    },
  };
};
